module.exports = __webpack_public_path__ + "img/login-logo.4a002c2e.png";